import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import type { SensitiveCredentialsApi } from '~/services/sensitive-credentials-api/sensitive-credentials-api.types';

import sensitiveCredentialsApi from '~/services/sensitive-credentials-api/sensitive-credentials-api';

type ResetParams = SensitiveCredentialsApi.ResetCredentialParams;

export default function useResetPartnerCredential() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ResetParams) => sensitiveCredentialsApi.resetCredential(params),
    onError: (error: any) => {
      const status = error?.response?.status;
      const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;

      const errorMessages = {
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || apiMessage
        || 'Erro inesperado ao resetar credencial.';

      toast.error(errorMessage);
    },
    onSuccess: (data, variables) => {
      toast.success(data.message || 'Credencial resetada com sucesso!');
      queryClient.invalidateQueries({ queryKey: ['partner-credentials', variables.partnerId] });
    },
    retry: false,
  });
}
